import { useGetVersionComparisonsQuery } from '@consigli/hooks';

import { DataTable } from '@/components';

import { versionComparisonColumns } from './version-compare-columns';

interface VersionCompareTabProps {
  projectId: number;
  packageId: string;
}

/**
 * The version-comparisons view for a VERSION_COMPARE package. Lists every
 * comparison (finding) produced by the version-compare pipeline.
 */
export const VersionCompareTab = ({ projectId, packageId }: VersionCompareTabProps) => {
  const { data, isLoading } = useGetVersionComparisonsQuery({
    projectId,
    packageId,
    page: 'all',
  });

  return (
    <div className="w-full space-y-4">
      <DataTable
        columns={versionComparisonColumns}
        data={data?.results || []}
        isLoading={isLoading}
        scrollable
        height="60vh"
      />
    </div>
  );
};
